var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountCenterWeb = function SvgAccountCenterWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3 10a7.7 7.7 0 1 1 15.4 0 7.7 7.7 0 0 1-15.4 0Zm2.736 3.88a6.3 6.3 0 1 1 9.974-.059 6.29 6.29 0 0 0-4.964-2.421 6.29 6.29 0 0 0-5.01 2.48Zm.994 1.012A6.274 6.274 0 0 0 10 16.3a6.275 6.275 0 0 0 4.028-1.456 4.894 4.894 0 0 0-3.982-2.044 4.894 4.894 0 0 0-4.016 2.092Zm5.95-5.012a2.8 2.8 0 1 0-3.96-3.96 2.8 2.8 0 0 0 3.96 3.96Zm-.99-.99a1.4 1.4 0 1 0-1.98-1.98 1.4 1.4 0 0 0 1.98 1.98Z",
    fill: "#DC9B32"
  })));
};
export default SvgAccountCenterWeb;